import { Component } from "components/common";

/**
 * Eine Klasse zur Erstellung von HTML `<div>` Elementen.
 *
 * @example
 * Das folgende Beispiel erstellt ein HTML `<div>` Element.
 *
 * Erstelle ein neues HTML `<div>` Element.
 *
 * ```typescript
 * import { Division } from "components/common/division";
 *
 * const division = new Division();
 * ```
 *
 * Konfiguriere das HTML `<div>` Element durch Method Chaining.
 *
 * ```typescript
 * division
 *     .withID("division")
 *     .withClass("division");
 * ```
 *
 * Rendere nun das HTML `<div>` Element in das DOM.
 *
 * ```typescript
 * document.getElementById("root")
 *     ?.replaceChildren(division.render());
 * ```
 *
 * @public
 */
class Division extends Component<HTMLDivElement> {
  /**
   * Erstellt ein neues HTML `<div>` Element.
   */
  constructor() {
    super(document.createElement("div"));
  }
}

export { Division };
